module.exports = __webpack_public_path__ + "img/charles-deluvio-Za9oagRJNLM-unsplash.9d7220f6.jpg";